// extracted by mini-css-extract-plugin
module.exports = {"base":"Q6A1JYZAu3ej5PsXilGxr"};